import { render, staticRenderFns } from "./JdsSpotlight.vue?vue&type=template&id=41991076&scoped=true&"
import script from "./JdsSpotlight.vue?vue&type=script&lang=ts&"
export * from "./JdsSpotlight.vue?vue&type=script&lang=ts&"
import style0 from "./JdsSpotlight.vue?vue&type=style&index=0&id=41991076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41991076",
  null
  
)

export default component.exports